var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeClimIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3958;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#9E1F22;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D82927;}\n\t.st3{fill:#E75425;}\n\t.st4{fill:#F27C2A;}\n\t.st5{fill:#FCC021;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.7,166l4.1,4.2l22.3-21.8l-4.1-4.2c-12.5-12.8-18.5-29.5-18.2-46H32.6C32.3,123.7,41.9,147.8,59.7,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.8,98.2c0.3-16.3,6.7-32.5,19.3-44.8l0,0l-22-22C43.1,49.1,32.9,72.9,32.6,98.2H63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.1,31.4l22,22l0.5-0.4c12-11.5,27.7-17.8,44.4-17.8L128,4c-25,0-48.7,9.6-66.6,27.1 C61.3,31.2,61.2,31.3,61.1,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128,4l0,31.2l0,0c17.4,0,33.2,7,44.8,18.3l22-22C177.6,14.5,154,4,128,4L128,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.8,31.4l-22,22v0c11.7,11.4,19.1,27.2,19.4,44.8h31.2C223.1,72.1,212.2,48.5,194.8,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.4,98.2h-31.2c0,0.4,0,0.8,0,1.2c0,16.9-6.5,32.8-18.3,44.8l-30.4,31.1v-33c18.2-6.4,31.2-23.8,31.2-44.2 c0-25.9-21-46.8-46.8-46.8c-25.9,0-46.8,21-46.8,46.8c0,20.4,13,37.7,31.2,44.2V252l83.9-86c17.5-17.9,27.1-41.6,27.1-66.6 C223.4,99,223.4,98.6,223.4,98.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeClimIcon);
export default __webpack_public_path__ + "static/media/VEClim-Icon.176fd063bf43396e97fa8134ec0acbee.svg";
export { ForwardRef as ReactComponent };